import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, Menu, ListItemIcon, IconButton, MenuItem } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import DeleteFolder from "./delete-folder";
import AddFolder from "./add-folder";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import host from "../host";
import JSZip from "jszip";
import { saveAs } from "file-saver";
export default function FolderActions(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openhistoryaction = Boolean(anchorEl);
  const handleClickaction = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //this below function for openknowledge     popup start//
  const [openeditfile, setOpeneditfile] = React.useState(false);
  const activeeditfile = () => setOpeneditfile(true);
  const handleCloseeditfile = () => setOpeneditfile(false);
  //this below function for openknowledge     popup end//

  //this below function for add folder   popup start//
  const [openaddfolder, setOpenaddfolder] = React.useState(false);
  const activeaddfolder = () => setOpenaddfolder(true);
  const handleCloseaddfolder = () => setOpenaddfolder(false);
  //this below function for add brain   popup end//
  //this below function for delete member   popup start//
  const [opendelete, setOpendelete] = React.useState(false);
  const activedelet = () => setOpendelete(true);
  const handleClosedelete = () => setOpendelete(false);
  //this below function for delete member   popup end//

  const [loading, setLoading] = React.useState(false);

  const handleDownloadFolder = (brain_id) => {
    setLoading(true);
    fetch(host.chaturl + `/brain/${brain_id}/download`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          handleClose();
          setLoading(false);
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          handleClose();
          setLoading(false);
          console.error("Something went wrong");
        }
      })
      .then((data) => {
        setLoading(false);
        const zip = new JSZip();
        let count = 0;
        data.forEach((url, index) => {
          fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
              zip.file(`file${index + 1}`, blob, { binary: true });
              count++;
              if (count === data.length) {
                zip.generateAsync({ type: "blob" }).then((content) => {
                  saveAs(content, "Folder.zip");
                });
              }
            });
        });
        // handleClose();
      })
      .catch((error) => {
        handleClose();
        setLoading(false);
        console.error("Error uploading file:", error);
      });
  };
  return (
    <>
      <Tooltip title="Actions">
        <IconButton onClick={handleClickaction} size="small" aria-controls={open ? "account-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined}>
          <MoreHorizIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openhistoryaction}
        onClose={handleClose}
        // onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={activeeditfile}>
          <ListItemIcon>
            <EditNoteOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Rename Folder
        </MenuItem>
        {/* <MenuItem>
          <ListItemIcon>
            <ShareOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Share
        </MenuItem> */}
        <MenuItem onClick={() => handleDownloadFolder(props?.brain?.id)}>
          <ListItemIcon>
            <FileDownloadOutlinedIcon fontSize="small" />
          </ListItemIcon>
          {loading ? "Downloading Folder" : "Download Folder"}
        </MenuItem>
        <MenuItem onClick={activedelet}>
          <ListItemIcon>
            <DeleteOutlineOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Delete Folder
        </MenuItem>
        <MenuItem component={Link} to={`/brain-setting/${props.brain.id}`}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          Folder Settings
        </MenuItem>
      </Menu>
      {/* <RenameFile openeditfile={openeditfile} handleCloseeditfile={handleCloseeditfile} /> */}
      <DeleteFolder
        brain={props?.brain}
        getBrains={props.getBrains}
        opendelete={opendelete}
        handleClosedelete={handleClosedelete}
        setSnackbar={props.setSnackbar}
        setSeverity={props.setSeverity}
        setMessage={props.setMessage}
      />
      <AddFolder openaddfolder={openaddfolder} handleCloseaddfolder={handleCloseaddfolder} />
    </>
  );
}
